import {getAbsoluteUrl} from "../../utils/urlUtill";


class CalculationsService {

    constructor($http, $log) {
        this.$http = $http;
        this.log = $log;
    }

    getCalculations = () => {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/calculators')
        });
    }
}

export const CALCULATIONS_SERVICE = ['$http', '$log', CalculationsService];